import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DockerOutlinedSvg from "@ant-design/icons-svg/es/asn/DockerOutlined";
import AntdIcon from '../components/AntdIcon';
var DockerOutlined = function DockerOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DockerOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DockerOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DockerOutlined';
}
export default RefIcon;